import React from 'react';

const DrilldownContext = React.createContext(React.createRef<HTMLElement>());

export const DrilldownProvider = DrilldownContext.Provider;

export const useDrilldownContext = () => React.useContext(DrilldownContext);
